import FieldsCollection from "../../fields3/collection/base/fields-collection"
import {FieldType} from "../../fields3/field-type"
import Field1ToField2Converter from "../../fields3/fields-converter-1-2"
import FieldsFactory from "../../fields3/fields-factory"
import FieldString from "../../fields3/generic/string/string";
import FieldProject from "../../fields3/generic/entity/project/project";
import FieldStoryPoints from "../../fields3/generic/story-points/story-points";
import FieldTaskAssignedToUser from "../../fields3/system/task/user/assigned-to-user/assigned-to-user";
import FieldTaskSystemStatus from "../../fields3/system/task/system-status/system-status";
import FieldTaskPriority from "../../fields3/system/task/priority/priority";
import FieldTaskStatus from "../../fields3/system/task/status/status";
import FieldTaskActionRequiredUser from "../../fields3/system/task/user/action-required-user/action-required-user";
import FieldDate from "../../fields3/generic/datetime/date/date";
import {EntityType} from "../../gd/const/item";
import FieldTaskId from "../../fields3/system/task/short-id/task-id"
import {GroupedData} from "../../data-structures/group";
import {SEPARATOR} from "../../gd-components/popover-menu/const";
import CustomFieldsManager from "../../gd/manager/custom-fields-manager";
import FieldProto from "../../fields3/proto/field-proto";
import FieldEstimate from "../../fields3/generic/estimate/estimate";
import FieldCrmAccount from "../../fields3/system/crm/account/crm-account";
import FieldCrmContacts from "../../fields3/system/crm/contacts/crm-contacts";
import FieldCurrency from "../../fields3/generic/finance/currency/currency";
import FieldTaskTimeReported from "../../fields3/system/task/time-reported/time-reported";
import {filterTasksCustomFields} from "./functions/filter-tasks-custom-fields"
import FieldTaskProgress from "../../fields3/system/task/progress/progress";
import FieldText from "../../fields3/generic/text/text";
import FieldEstimatedCostInternal from "../../fields3/generic/finance/cost-estimated/estimated-cost-internal";
import FieldEstimatedCostExternal from "../../fields3/generic/finance/cost-estimated/estimated-cost-external";
import {QuickFilterField} from "../../gd/const/quick-filter";
import FieldTaskType from "../../fields3/system/task/task-type/task-type";
import FieldConfig from "../../fields3/proto/field-config";
import FieldMessagesTotal from "../../fields3/generic/total/messages/messages-total";
import FieldAttachmentsTotal from "../../fields3/generic/total/attachments/attachments-total";
import FieldTaskCreatedBy from "../../fields3/system/task/user/created-by/created-by";
import FieldTaskMomentCreated from "../../fields3/system/task/date/moment-created/moment-created";
import FieldTaskMomentClosed from "../../fields3/system/task/date/moment-closed/moment-closed";
import FieldTaskProgressItems from "../../fields3/system/task/progress-items/progress-items";
import FieldTaskDurationWorkdays from "../../fields3/system/task/duration/duration-workdays";
import FieldTaskDurationCalendar from "../../fields3/system/task/duration/duration-calendar";
import FieldTaskUsers from "../../fields3/system/task/users/users";
import FieldTaskDeadline from "../../fields3/system/task/date/deadline/deadline"
import FieldTaskSchedule from "../../fields3/system/task/date/schedule/schedule"
import FieldTaskStartDate from "../../fields3/system/task/date/start-date/start-date"
import FieldTaskEndDate from "../../fields3/system/task/date/end-date/end-date"
import FieldTaskStartEnd from "../../fields3/system/task/date/start-end/start-end";
import FieldPredecessors from "../../fields3/generic/dependency/predecessors/predecessors"
import FieldSuccessors from "../../fields3/generic/dependency/successors/dependants"
import FieldTaskTags from "../../fields3/system/task/tags/tags"
import FieldTaskLeadTime from "../../fields3/system/task/date/lead-time/lead-time"
import FieldTaskAge from "../../fields3/system/task/date/age/age"
import FieldTaskStoryPoints from "../../fields3/system/task/story-points/story-points"
import FieldTaskLatestActivityMoment
    from "../../fields3/system/task/date/latest-activity-moment/latest-activity-moment"
import FieldProjectPath from "../../fields3/generic/project-path/project-path";

/*
1. task.XXX - odin raz opisan

    gd.fields.task.XXX

    TaskFieldXXX Type


2. client task.XXX  = server task.XXX

    fieldId - cut in stone
    fieldType







 */



const baseConfig : FieldConfig[] = [

    // Tille shoudl be first - csv import preview issues kakie to :)
    {
        fieldId: 'title',
        label: 'Title',
        type: FieldType.STRING
    },

    {
        fieldId     : 'descriptionTxt',
        label       : 'Description',
        type        : FieldType.TEXT
    },

    { fieldId: 'shortId',               label: 'ID',                        type: FieldType.TASK_ID },

    { fieldId: 'projectId',             label: 'Project',                   type: FieldType.TASK_PROJECT },
    {
        fieldId     : 'parentPath',
        label       : 'Parent path',
        type        : FieldType.PROJECT_PATH,
        maxParents  : 2
    },
    // { fieldId: 'projectId',             label: 'Project',                   type: FieldType.TASK_PROJECT},
    { fieldId: 'taskTypeId',            label: 'Task Type',                 type: FieldType.TASK_TYPE },    // experimental

    {fieldId: 'statusId',               label: 'Status',                    type: FieldType.TASK_STATUS},
    {fieldId: 'parentTaskId',           label: 'Parent Task',               type: FieldType.TASK_PARENT_TASK},
    {fieldId: 'actionRequiredUserId',   label: 'Action required',           type: FieldType.TASK_ACTION_REQUIRED},
    {fieldId: 'assignedToUserId',       label: 'Assigned to',               type: FieldType.TASK_ASSIGNED_TO},
    {
        // !!!! I think we need to mark it as read only somehow
        fieldId: 'createdByUserId',     label: 'Created by',                type: FieldType.TASK_CREATED_BY

    },
    {fieldId: 'allUsers',               label: 'All users',                 type: FieldType.TASK_USERS},
    {fieldId: 'priority',               label: 'Priority',                  type: FieldType.TASK_PRIORITY},

    {fieldId: 'crmAccountId',           label: 'CRM Account',               type: FieldType.CRM_ACCOUNT},
    {fieldId: 'crmContactIds',          label: 'CRM Contacts',              type: FieldType.CRM_CONTACTS},

    {fieldId: 'startEnd',               label: 'Start/End',                 type: FieldType.TASK_START_END},

    {
        fieldId     : 'durationWorkdays',
        label       : 'Duration, workdays',
        type        : FieldType.TASK_DURATION_WORKDAYS,
    },
    {
        fieldId     : 'durationCalendar',
        label       : 'Duration, calendar',
        type        : FieldType.TASK_DURATION_CALENDAR,
    },

    {
        fieldId     : 'deadline',
        type        : FieldType.TASK_DEADLINE
    },

    {fieldId: 'momentCreated',          label: 'Date created',              type: FieldType.TASK_MOMENT_CREATED, icon        : 'i5-date-created' },
    {fieldId: 'momentClosed',           label: 'Date closed',               type: FieldType.TASK_MOMENT_CLOSED, icon         : 'i5-date-closed' },

    {
        fieldId: 'scheduleDate',
        type: FieldType.TASK_SCHEDULE
    },

    {
        fieldId: 'startDate',
        type: FieldType.TASK_START_DATE
    },

    {
        fieldId: 'endDate',
        type: FieldType.TASK_END_DATE
    },

    { fieldId: 'latestActivityMoment',  type: FieldType.TASK_LATEST_ACTIVITY_MOMENT },

    {fieldId: 'storyPoints',            label: 'Story points',              type: FieldType.TASK_STORY_POINTS},
    {fieldId: 'estimate',               label: 'Estimate',                  type: FieldType.TASK_ESTIMATE },
    {fieldId: 'progress',               label: 'Progress',                  type: FieldType.TASK_PROGRESS },
    {fieldId: 'progressItems',          label: 'Progress, items',           type: FieldType.TASK_PROGRESS_ITEMS },

    {fieldId: 'systemStatus',           label: 'System status',             type: FieldType.TASK_SYSTEM_STATUS},

    {fieldId: 'tags',                   label: 'Tags',                      type: FieldType.TASK_TAGS},

    // Time reports
    {fieldId: 'reportedTimeMinutes',    label: 'Time reported',             type: FieldType.TASK_TIME_REPORTED},
    {fieldId: 'costInternal',           label: 'Internal Cost',             type: FieldType.CURRENCY},
    {fieldId: 'costExternal',           label: 'External Cost',             type: FieldType.CURRENCY},



    {fieldId: 'expensesTotal',           label: 'Expenses',             type: FieldType.CURRENCY},   // data usually taken from task.properties.expensesTatal or task.expenses

    {
        // has no model field! which is ok ... used in table only
        fieldId         : 'estimatedCostInternal',
        type            : FieldType.ESTIMATED_COST_INTERNAL,
        label           : 'Estimated labor cost'
    },
    {
        // has no model field! which is ok ... used in table only
        fieldId         : 'estimatedCostExternal',
        type            : FieldType.ESTIMATED_COST_EXTERNAL,
        label           : 'Estimated service cost'
    },

    {
        fieldId         : 'messagesTotal',
        type            : FieldType.MESSAGES_TOTAL,
        label           : 'Messages'
    },

    {
        fieldId         : 'attachmentsTotal',
        type            : FieldType.ATTACHMENTS_TOTAL,
        label           : 'Attachments'
    },
    {
        fieldId         : 'predecessors',
        type            : FieldType.PREDECESSORS,
        label           : 'Depends on'
    },
    {
        fieldId         : 'successors',
        type            : FieldType.SUCCESSORS,
        label           : 'Dependants'
    },
    {
        fieldId         : 'leadTime',
        type            : FieldType.TASK_LEAD_TIME,
        label           : 'Lead time'
    },
    {
        fieldId         : 'age',
        type            : FieldType.TASK_AGE,
        label           : 'Age'
    },
]

export type TaskFieldsOptions = {
    customFieldsIds?    : ID[]
}

export default class TaskFields extends FieldsCollection {

    private isCompanyManager: boolean = false

    constructor(options:TaskFieldsOptions = {}) {
        const {customFieldsIds} = options;

        const customFieldsConfig : any = []
        _.map(customFieldsIds, customFieldId=>{
            const field2Config = Field1ToField2Converter.getField2Config(customFieldId)
            if (field2Config) customFieldsConfig.push(field2Config)
        })

        const fieldsConfig = _.union(baseConfig, customFieldsConfig)

        super(fieldsConfig, EntityType.TASK)

        this.isCompanyManager = gd.ac.check.company.isManager(gd.companyId)
        if (_.isEmpty(customFieldsIds)) {
            this.initAllCustomFields()
        }
    }

    // Quick access

    get title()                 : FieldString { return this.get('title') as FieldString }
    get description()           : FieldString { return this.get('descriptionTxt') as FieldText }
    get projectId()             : FieldProject { return this.get('projectId') as FieldProject }
    get parentPath()            : FieldProjectPath { return this.get('parentPath') as FieldProjectPath }
    get taskTypeId()            : FieldTaskType { return this.get('taskTypeId') as FieldTaskType}
    get startEnd()              : FieldTaskStartEnd { return this.get('startEnd') as FieldTaskStartEnd}
    get storyPoints()           : FieldTaskStoryPoints { return this.get('storyPoints') as FieldTaskStoryPoints}
    get estimate()              : FieldEstimate { return this.get('estimate') as FieldEstimate}
    get assignedToUserId()      : FieldTaskAssignedToUser { return this.get('assignedToUserId') as FieldTaskAssignedToUser}
    get createdByUserId()       : FieldTaskCreatedBy { return this.get('createdByUserId') as FieldTaskCreatedBy}

    get users()                 : FieldTaskUsers { return this.get('allUsers') as unknown as FieldTaskUsers}
    get durationWorkdays()      : FieldTaskDurationWorkdays { return this.get('durationWorkdays') as FieldTaskDurationWorkdays}
    get durationCalendar()      : FieldTaskDurationCalendar { return this.get('durationCalendar') as FieldTaskDurationCalendar}
    get systemStatus()          : FieldTaskSystemStatus { return this.get('systemStatus') as FieldTaskSystemStatus}
    get priority()              : FieldTaskPriority { return this.get('priority') as FieldTaskPriority}
    get statusId()              : FieldTaskStatus { return this.get('statusId') as FieldTaskStatus}
    get actionRequiredUserId()  : FieldTaskActionRequiredUser { return this.get('actionRequiredUserId') as FieldTaskActionRequiredUser}
    get deadline()              : FieldTaskDeadline { return this.get('deadline') as FieldTaskDeadline}
    get progress()              : FieldTaskProgress { return this.get('progress') as FieldTaskProgress}
    get progressItems()         : FieldTaskProgressItems { return this.get('progressItems') as FieldTaskProgressItems}
    get momentClosed()          : FieldTaskMomentClosed { return this.get('momentClosed') as FieldTaskMomentClosed}
    get momentCreated()         : FieldTaskMomentCreated { return this.get('momentCreated') as FieldTaskMomentCreated}
    get leadTime()              : FieldTaskLeadTime { return this.get('leadTime') as FieldTaskLeadTime}
    get age()                   : FieldTaskAge { return this.get('age') as FieldTaskAge}
    get latestActivityMoment()  : FieldTaskLatestActivityMoment { return this.get('latestActivityMoment') as FieldTaskLatestActivityMoment}
    get shortId()               : FieldTaskId { return this.get('shortId') as FieldTaskId}
    get scheduleDate()          : FieldTaskSchedule { return this.get('scheduleDate') as FieldTaskSchedule}
    get startDate()             : FieldTaskStartDate { return this.get('startDate') as FieldTaskStartDate}
    get endDate()               : FieldTaskEndDate { return this.get('endDate') as FieldTaskEndDate}
    get crmAccountId()          : FieldCrmAccount { return this.get('crmAccountId') as FieldCrmAccount}
    get crmContactIds()         : FieldCrmContacts { return this.get('crmContactIds') as unknown as FieldCrmContacts}

    // get timeReported()          : FieldStoryPoints { return this.get('reportedTimeMinutes') }
    get reportedTimeMinutes()   : FieldTaskTimeReported { return this.get('reportedTimeMinutes') as FieldTaskTimeReported}
    get costInternal()          : FieldCurrency { return this.get('costInternal') as FieldCurrency}
    get costExternal()          : FieldCurrency { return this.get('costExternal') as FieldCurrency}
    get expensesTotal()         : FieldCurrency { return this.get('expensesTotal') as FieldCurrency}
    get estimatedCostInternal() : FieldEstimatedCostInternal { return this.get('estimatedCostInternal') as FieldEstimatedCostInternal}
    get estimatedCostExternal() : FieldEstimatedCostExternal { return this.get('estimatedCostExternal') as FieldEstimatedCostExternal}
    get tags()                  : FieldTaskTags { return this.get('tags') as unknown as FieldTaskTags}
    get messagesTotal()         : FieldMessagesTotal { return this.get('messagesTotal') as FieldMessagesTotal}
    get attachmentsTotal()      : FieldAttachmentsTotal { return this.get('attachmentsTotal') as FieldAttachmentsTotal}
    get predecessors()          : FieldPredecessors { return this.get('predecessors') as FieldPredecessors}
    get successors()            : FieldSuccessors { return this.get('successors') as FieldSuccessors}


    // End Quick access

    reset(options:any) {
        const {customFieldsIds} = options

        const customFieldsConfig : any[] = []
        _.map(customFieldsIds, customFieldId=>{
            const field2Config = Field1ToField2Converter.getField2Config(customFieldId)
            if (field2Config) customFieldsConfig.push(field2Config)
        })

        const fieldsConfig = _.union(baseConfig, customFieldsConfig)

        this._fields = []

        _.map(fieldsConfig, fieldConfig=>{
            this.addField(FieldsFactory.get(fieldConfig))
        })
    }

    getQuickFilterFields() : QuickFilterField[] {
        const quickFiltersOptions = [
            // add system fields manually to keep good order (!)
            { id: 'statusId',               label: 'Status'},
            { id: 'systemStatus',           label: 'System status'},
            { id: 'projectId',              label: 'Project'},
            { id: 'actionRequiredUserId',   label: 'Action required'},
            { id: 'assignedToUserId',       label: 'Assigned to'},
            { id: 'priority',               label: 'Priority'},
            { id: 'storyPoints',            label: 'Story points'},
            { id: 'taskTypeId',             label: 'Task type'},
        ]

        // add custom fields available for quick filter (i.e. available to group by)
        _.map(this.customFields(), (field:FieldProto)=>{
            if (field.isGroupByAvailable)
                quickFiltersOptions.push({
                    id      : field.fieldId,
                    label   : field.label,
                })
        })

        return quickFiltersOptions
    }

    // Used at least in TABLE view... chto mne ne nravitsya esli chestno
    getFieldByField1Id(id:string) {
        let res
        switch (id) {
            case gd.const.fields.type.STATUS            : res = this.get('statusId'); break
            case gd.const.fields.type.SYSTEM_STATUS     : res = this.get('systemStatus'); break
            case gd.const.fields.type.PROJECT           : res = this.get('projectId'); break
            case gd.const.fields.type.ACTION_REQUIRED   : return this.actionRequiredUserId
            case gd.const.fields.type.ASSIGNED_TO       : return this.assignedToUserId
            case gd.const.fields.type.PRIORITY          : res = this.get('priority'); break
            case gd.const.fields.type.STORY_POINTS      : res = this.get('storyPoints'); break
            case gd.const.fields.type.TASK_TYPE         : res = this.get('taskTypeId'); break
            case gd.const.fields.type.CRM_ACCOUNT       : res = this.get('crmAccountId'); break
            case gd.const.fields.type.CRM_CONTACTS      : return this.crmContactIds
            case FieldType.ESTIMATED_COST_INTERNAL      : return this.estimatedCostInternal // need in table
            case FieldType.ESTIMATED_COST_EXTERNAL      : return this.estimatedCostExternal // need in table
            case 'noGrouping'                           : res = null; break
            default                                     : res = this.get(id); /* in this case id is customFieldId */ break
        }
        return res
    }

    getField1IdByField(field:any) {
        let res
        if (field) {
            switch (field.fieldId) {
                case 'statusId'             : res = gd.const.fields.type.STATUS; break
                case 'systemStatus'         : res = gd.const.fields.type.SYSTEM_STATUS; break
                case 'projectId'            : res = gd.const.fields.type.PROJECT; break
                case 'actionRequiredUserId' : res = gd.const.fields.type.ACTION_REQUIRED; break
                case 'assignedToUserId'     : res = gd.const.fields.type.ASSIGNED_TO; break
                case 'priority'             : res = gd.const.fields.type.PRIORITY; break
                case 'storyPoints'          : res = gd.const.fields.type.STORY_POINTS; break
                case 'taskTypeId'           : res = gd.const.fields.type.TASK_TYPE; break
                default                     : res = field.fieldId; /* in this case fieldId is customFieldId */ break
            }
        } else {
            res = 'noGrouping'
        }
        return res
    }

    public hasField = (fieldId:fieldId): boolean => {
        return !!_.find(this._fields, field=>field.fieldId === fieldId)
    }

    private isCustomFieldAvailable = (customField:any): boolean => {
        return (this.isCompanyManager || customField.access === gd.const.customFields.access.EVERYONE) &&
            _.intersection(customField.params.scope, [gd.const.customFields.scope.TASK]).length > 0 &&
            !customField.isDeleted
    }

    public addCustomField(customField:any) {
        if (!this.isCustomFieldAvailable(customField)) return

        const field2Config = Field1ToField2Converter.getField2Config(customField.id)
        if (field2Config                                                // field config successfully created
            && !this.hasField(field2Config.fieldId)                     // field with same ID does not exist in this (TaskFields) fields collection
            && gd.session.customFields.get(field2Config?.fieldId)) {    // custom field exists in session
            this.addField(FieldsFactory.get(field2Config))
        }
    }

    public initAllCustomFields() {
        const customFields = CustomFieldsManager.getOrganizationCustomFields(gd.companyId, [gd.const.customFields.scope.TASK])
        _.map(customFields, customField=>{this.addCustomField(customField)})
    }

    get structureConditions():GroupedData {

        // this.initAllCustomFields()
        //
        // const customFields : FieldProto[] = this.customFields()

        return [
            {
                value     : 'general',
                label   : 'General',
                type   : 'system',
                items      : [
                    // this.shortId,
                    // this.projectId,
                    this.statusId,
                    this.systemStatus,
                    this.priority,
                    this.taskTypeId,
                    // SEPARATOR,

                ]
            },
            {
                value     : 'users',
                label   : 'Users',
                type   : 'system',
                items      : [
                    this.actionRequiredUserId,
                    this.assignedToUserId,
                    this.createdByUserId
                    // SEPARATOR,

                ]
            },
            {
                value  : 'dates',
                label  : 'Dates',
                type   : 'system',
                items      : [
                    this.deadline,
                    this.scheduleDate,
                    this.startDate,
                    this.endDate,
                    // this.startEnd,
                    SEPARATOR,
                    this.latestActivityMoment,
                    this.momentClosed,
                    this.momentCreated

                ]
            },
            {
                value     : 'estimate',
                label   : 'Estimate',
                type   : 'system',
                items      : [
                    this.estimate,
                    this.storyPoints

                ]
            },
            {
                value     : 'crm',
                label   : 'CRM',
                type   : 'system',
                items      : [
                    this.crmAccountId,
                    this.crmContactIds

                ]
            }
            // , {
            //     value       : 'custom-fields', // DO NOT CALL IT 'custom'!!!!
            //     label       : 'Custom',
            //     type        : 'custom-fields',
            //     items       : customFields
            // }
        ]
    }

    get structureWidgetProperty():GroupedData {

        this.initAllCustomFields()

        const customFields : FieldProto[] = this.customFields()

        return [
            {
                value     : 'general',
                label   : 'General',
                type   : 'system',
                items      : [
                    this.shortId,
                    this.projectId,
                    // this.title,
                    this.statusId,
                    this.priority,
                    this.taskTypeId,
                    // SEPARATOR,

                ]
            },
            {
                value     : 'users',
                label   : 'Users',
                type   : 'system',
                items      : [
                    this.actionRequiredUserId,
                    this.assignedToUserId,
                    this.createdByUserId
                    // SEPARATOR,

                ]
            },
            {
                value  : 'dates',
                label  : 'Dates',
                type   : 'system',
                items      : [
                    this.deadline,
                    this.scheduleDate,
                    this.startDate,
                    this.endDate,
                    this.startEnd,
                    SEPARATOR,
                    this.latestActivityMoment,
                    this.momentClosed,
                    this.momentCreated

                ]
            },
            {
                value     : 'estimate',
                label   : 'Estimate',
                type   : 'system',
                items      : [
                    this.estimate,
                    this.storyPoints

                ]
            },
            {
                value     : 'crm',
                label   : 'CRM',
                type   : 'system',
                items      : [
                    this.crmAccountId,
                    this.crmContactIds

                ]
            },
            {
                value       : 'custom-fields', // DO NOT CALL IT 'custom'!!!!
                label       : 'Custom',
                type        : 'custom-fields',
                items       : customFields
            }
        ]
    }

    get structureForGrouping():GroupedData {
        // this.initAllCustomFields()
        const groupByCustomFields = _.filter(this.customFields(), (field:FieldProto)=>{
            return field.isGroupByAvailable
        })

        return [
            {
                value   : 'general',
                label   : 'General',
                type    : 'system',
                items   : [
                    this.statusId,
                    this.systemStatus,
                    this.projectId,
                    this.priority,
                    this.taskTypeId,
                ]
            },
            {
                value   : 'users',
                label   : 'Users',
                type    : 'system',
                items   : [
                    this.actionRequiredUserId,
                    this.assignedToUserId,
                ]
            },
            {
                value   : 'dates',
                label   : 'Dates',
                type    : 'system',
                items   : [
                    this.deadline,
                    this.startDate,
                    this.endDate,
                    this.scheduleDate,
                    SEPARATOR,
                    this.momentCreated,
                    this.momentClosed,
                    this.latestActivityMoment,
                ]
            },
            {
                value   : 'estimate',
                label   : 'Estimate',
                type    : 'system',
                items   : [
                    this.storyPoints
                ]
            },
            {
                value   : 'custom-fields', // DO NOT CALL IT 'custom'!!!!
                label   : 'Custom',
                type    : 'custom-fields',
                items   : groupByCustomFields
            }
        ]
    }

    get structureGroupBy():GroupedData {

        this.initAllCustomFields()
        const groupByCustomFields = _.filter(this.customFields(), (field:FieldProto)=>{
            return field.isGroupByAvailable
        })

        return [
            {
                value     : 'general',
                label   : 'General',
                type   : 'system',
                items      : [
                    // this.shortId,
                    // this.projectId,
                    // this.title,
                    this.statusId,
                    // this.systemStatus,
                    this.priority,
                    this.taskTypeId,
                    // SEPARATOR,

                ]
            },
            {
                value     : 'users',
                label   : 'Users',
                type   : 'system',
                items      : [
                    this.actionRequiredUserId,
                    this.assignedToUserId,
                    this.createdByUserId
                    // SEPARATOR,

                ]
            },
            // {
            //     value  : 'dates',
            //     label  : 'Dates',
            //     type   : 'system',
            //     items      : [
            //         this.deadline,
            //         this.scheduleDate,
            //         this.startDate,
            //         this.endDate,
            //         this.startEnd,
            //         SEPARATOR,
            //         this.latestActivityMoment,
            //         this.momentClosed,
            //         this.momentCreated
            //     ]
            // },
            {
                value     : 'estimate',
                label   : 'Estimate',
                type   : 'system',
                items      : [
                    // this.estimate,
                    this.storyPoints
                ]
            },
            {
                value     : 'crm',
                label   : 'CRM',
                type   : 'system',
                items      : [
                    this.crmAccountId,
                    // this.crmContactIds
                ]
            }
            , {
                value       : 'custom-fields', // DO NOT CALL IT 'custom'!!!!
                label       : 'Custom',
                type        : 'custom-fields',
                items       : groupByCustomFields
            }
        ]
    }

    structureColorCoding(options?: {
        taskTypesIds?       : ID[],
        projectId?          : ID
        customFieldsIds?    : ID[]
    }):GroupedData {
        // this.initAllCustomFields()

        const groupByCustomFields = filterTasksCustomFields(this.customFields(), options)

        return [
            {
                value   : 'general',
                label   : 'System fields',
                type    : 'system',
                items   : [
                    this.projectId,
                    this.statusId,
                    this.priority,
                ]
            },
            {
                value   : 'custom-fields', // DO NOT CALL IT 'custom'!!!!
                label   : 'Custom fields',
                type    : 'custom-fields',
                items   : groupByCustomFields
            }
        ]
    }

    // request form fields
    structureForm(hiddenFieldsIds?: string[], availableCustomFieldsIds?: string[]):GroupedData {

        const excludeFieldsIds  = hiddenFieldsIds || []

        this.initAllCustomFields()
        const formCustomFields = _.filter(this.customFields(), (field:FieldProto)=>{
            return !availableCustomFieldsIds || availableCustomFieldsIds.includes(field.fieldId)
        })

        const res = [{
            value   : 'general',
            label   : 'General',
            type    : 'system',
            items   : [
                // this.statusId,
                this.description,
                this.priority,
                this.tags,
            ]
        }, {
            value   : 'users',
            label   : 'Users',
            type    : 'system',
            items   : [
                // this.actionRequiredUserId,
                this.assignedToUserId,
            ]
        }, {
            value   : 'dates',
            label   : 'Dates',
            type    : 'system',
            items   : [
                this.startEnd,
                this.deadline,
                this.scheduleDate,
            ]
        }, {
            value   : 'estimate',
            label   : 'Estimate',
            type    : 'system',
            items   : [
                this.estimate,
                this.storyPoints
            ]
        }, {
            value   : 'custom-fields', // DO NOT CALL IT 'custom'!!!!
            label   : 'Custom',
            type    : 'custom-fields',
            items   : formCustomFields
        }]

        _.map(res, (group:any) => {
            group.items = _.filter(group.items, item=>item && !excludeFieldsIds.includes(item.fieldId))
        })

        return res
    }

    get structureSorting():GroupedData {

        this.initAllCustomFields()

        const customFields : FieldProto[] = this.customFields()

        return [
            {
                value   : 'general',
                label   : 'General',
                type    : 'system',
                items      : [
                    this.title,
                    this.statusId,
                    this.priority,
                    this.taskTypeId,
                    this.progress,
                    this.messagesTotal,
                    this.attachmentsTotal,
                ]
            },
            {
                value     : 'users',
                label   : 'Users',
                type   : 'system',
                items      : [
                    // this.actionRequiredUserId,
                    this.assignedToUserId,
                    // this.createdByUserId
                    // SEPARATOR,
                ]
            },
            {
                value  : 'dates',
                label  : 'Dates',
                type   : 'system',
                items      : [
                    this.scheduleDate,
                    this.deadline,
                    // this.startDate,
                    // this.endDate,
                    // this.startEnd,
                    // SEPARATOR,
                    this.latestActivityMoment,
                    // this.momentClosed,
                    this.momentCreated
                ]
            },
            {
                value     : 'estimate',
                label   : 'Estimate',
                type   : 'system',
                items      : [
                    // this.estimate,
                    this.storyPoints
                ]
            },
            {
                value     : 'crm',
                label   : 'CRM',
                type   : 'system',
                items      : [
                    this.crmAccountId,
                    this.crmContactIds
                ]
            }
            , {
                value       : 'custom-fields', // DO NOT CALL IT 'custom'!!!!
                label       : 'Custom',
                type        : 'custom-fields',
                items       : customFields
            }
        ]
    }
}
